import PageHeadline from '../../components/molecules/headlines/PageHeadline'
import DecorationSubTitle from '../../components/atoms/decoration/DecorationSubTitle'

export default {
  components: { PageHeadline, DecorationSubTitle }
}
